import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonButton, IonIcon, modalController } from "@ionic/vue";

import CatalogProduct from "@/components/modal/CatalogProduct.vue";
import ModalControllerBase from "@/components/modal/modalControllerModals/ModalControllerBase.vue";
import CustomHeader from "@/components/basePageElements/CustomHeader.vue";

import { CatalogItem } from "@/types/supplier";

import { chevronBack } from "ionicons/icons";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReadOnlyProduct',
  props: {
    product: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalControllerBase, { contentClass: "light-light-background" }, {
    header: _withCtx(() => [
      _createVNode(CustomHeader, {
        "back-button": "",
        title: _ctx.$t('titleRoute.productDetails')
      }, {
        start: _withCtx(() => [
          _createVNode(_unref(IonButton), {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss())),
            class: "purple-light-color"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), { icon: _unref(chevronBack) }, null, 8, ["icon"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('button.back')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    default: _withCtx(() => [
      _createVNode(CatalogProduct, {
        contained: "",
        product: __props.product,
        "target-stock": __props.product.targetStock ?? 0,
        onBack: _cache[1] || (_cache[1] = ($event: any) => (_unref(modalController).dismiss())),
        "read-only": ""
      }, null, 8, ["product", "target-stock"])
    ]),
    _: 1
  }))
}
}

})